
export const AGE_RESTRICTED_CREATORS = [
  {
    username: 'thelilyphillips',
    exitUrl: 'https://www.instagram.com/lilyphillip_s'
  },
  {
    username: 'clairegrimes_official',
    exitUrl: 'https://www.instagram.com/clairegrimes'
  },
];

/**
 * Check if a username requires age verification
 * @param {string} username - The username to check
 * @returns {boolean} - True if age verification is required
 */
export function isAgeRestricted(username) {
  if (!username) return false;
  return AGE_RESTRICTED_CREATORS.some(
    creator => creator.username.toLowerCase() === username.toLowerCase()
  );
}

/**
 * Get the exit URL for a specific creator
 * @param {string} username - The username to look up
 * @returns {string} - The exit URL or default to homepage
 */
export function getExitUrl(username) {
  if (!username) return '/';
  const creator = AGE_RESTRICTED_CREATORS.find(
    c => c.username.toLowerCase() === username.toLowerCase()
  );
  return creator?.exitUrl || '/';
}
